export default __webpack_public_path__ + "static/media/13.0fff078b.jpg";